module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AYDoSq/tc-custom/9781504094580.jpg?1718106013739",
      "alt": "This image is the cover for the book Miracle in March, Tarrin’s Bay"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Miracle in March, Tarrin’s Bay\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Starting again is never easy…"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Emma had travel plans, but when her family needed help, she stepped in and took over running their business."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The beachside cabins in Tarrin’s Bay might not have the same appeal as the French Riviera, but Emma finds happiness in the small-town community."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" When she finds that her ex-boyfriend, a man she left behind without explanation, is staying in one of the cabins, her tranquil existence is shattered."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" She knows she must share the secret she has been hiding for five years, but that’s easier said than done. And James has his own confession to make…"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" They aren’t the same people they were before, but is it time for a second chance? And when their secrets surface, might two people in need of a miracle remember the dreams they once had and be able to move on?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Juliet Madison\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0